import "core-js/modules/es.string.sub.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "hm-notice-x",
    style: {
      color: _vm.formData.textColor,
      backgroundColor: _vm.formData.bgColor,
      cursor: _vm.formData.pathLink ? "pointer" : "default"
    }
  }, [_c("p", {
    staticClass: "hm-notice-title",
    style: {
      fontSize: _vm.formData.main.fontSize + "px"
    }
  }, [_vm._v(_vm._s(_vm.formData.main.title[_vm.defaultLangId]))]), _c("p", {
    staticClass: "hm-notice-subtitle",
    style: {
      fontSize: _vm.formData.sub.fontSize + "px"
    }
  }, [_vm._v(_vm._s(_vm.formData.sub.title[_vm.defaultLangId]))]), _c("div", {
    staticClass: "hm-notice-close"
  }, [_vm._v(" " + _vm._s(_vm.$t("close")) + " "), _c("i", {
    staticClass: "yy-icon-Close"
  })])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };